import styled from 'styled-components'

interface ContainerProps {
  isSelected: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  height: 40px;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 5px;
  background: ${({ isSelected }) => isSelected ? '#E9EBF4' : 'none'};

  &:hover {
    background: #E9EBF4;
  }

  & {
    .MenuDashboardItem__Title {
      margin-left: 10px;
    }

    .MenuDashboardItem__Badge {
      margin-left: 8px;
    }
  }
    
`